<template>
  <v-chip
    :color="`${getMaterialColor(color, {
      output: 'word',
    })} lighten-4`"
    :label="label"
    :class="[
      'font-weight-medium',
      `${getMaterialColor(color, { output: 'word' })}--text `,
      'text--darken-4',
    ]"
    :small="small"
    :x-small="xSmall"
    @click="$emit('click')"
  >
    <v-icon
      v-if="iconLeft"
      left
      :small="small || smallIcon"
      :x-small="xSmall"
      :color="`${getMaterialColor(color, {
        output: 'word',
      })} darken-4`"
    >
      mdi-{{ iconLeft }}
    </v-icon>
    <span class="font-weight-medium">{{ text }}</span>
    <v-icon
      v-if="iconRight"
      right
      :small="small || smallIcon"
      :color="`${getMaterialColor(color, {
        output: 'word',
      })} darken-4`"
    >
      mdi-{{ iconRight }}
    </v-icon>
  </v-chip>
</template>

<script>
import { getMaterialColor } from "@/util/styles";
export default {
  name: "data-chip",
  props: {
    iconRight: {
      type: String,
      required: false,
    },
    iconLeft: {
      type: String,
      required: false,
    },
    label: {
      type: Boolean,
      required: false,
      default: true,
    },
    color: {
      type: String,
      required: false,
      default: "grey",
    },
    text: {
      type: String,
      required: true,
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
    xSmall: {
      type: Boolean,
      required: false,
      default: false,
    },
    smallIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    getMaterialColor(color, options = {}) {
      return getMaterialColor(color, options);
    },
  },
};
</script>
